import React from "react";
import { connect, ConnectedProps } from "react-redux";
import LimitLine from "../../GameHeader/Stats/LimitLine";
import { formatNumberForceSigned } from "../../../lib/commonFunctions";

const mapStateToProps = (state: any) => ({
  magicEnergyBalance: state.governorate.resourceBalances.magicEnergy,
});

const connector = connect(mapStateToProps);

const WeaponsBalance = ({
  magicEnergyBalance
}: ConnectedProps<typeof connector>) => (
  <React.Fragment>
    <h3 className="title">Magic energy balance</h3>
    Magic apprentices: <span
    className={magicEnergyBalance.maxProduction > 0 ? "positive"
      : ""}>{formatNumberForceSigned(magicEnergyBalance.maxProduction)}</span><br/>
    <br />
    <LimitLine
      amount={magicEnergyBalance.limit.amount}
      limit={magicEnergyBalance.limit.limit}
      market={magicEnergyBalance.limit.market}
    />
  </React.Fragment>
);

export default connect(mapStateToProps)(WeaponsBalance);
